import React, { Component } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';

import '../../../chat.css';

/**
 * Class for the language selector component.
 */
class LanguageSelector extends Component {

    languageSelected = (countryCode) => {
        let languageChanged = this.props.languageSelected(countryCode);

        if (languageChanged === false) {
            this.refs.flagSelector.updateSelected(this.props.language.countryCode);
        }
    }

    render() {
        return(
            <div id={'control-button'}>
                {this.props.language && this.props.languageList && this.props.languageList.length > 1 ?
                <ReactFlagsSelect countries={this.props.languageList.map(lang => lang.countryCode)} 
                    defaultCountry={this.props.language.countryCode}
                    showSelectedLabel={false} 
                    showOptionLabel={false} 
                    selectedSize={14}
                    onSelect={this.languageSelected}
                    ref={'flagSelector'}/> : null}
                
            </div>
        );
    }
}

export default LanguageSelector;
